import React from "react"

const ApprovalReceipt = React.forwardRef(({ esmp }, ref) => {
  const receiptNumber = `ESMP-${esmp.id}-${new Date().getFullYear()}`
  const approvalDate = new Date().toLocaleDateString()

  return (
    <div
      ref={ref}
      className="relative p-10 text-sm text-gray-800 bg-white"
    >
      {/* WATERMARK */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="text-6xl font-bold text-green-100 rotate-[-30deg]">
          APPROVED
        </span>
      </div>

      {/* HEADER */}
      <div className="relative z-10 flex items-center justify-between mb-8">
        <div>
          {/* Replace with logo if available */}
          <div className="w-16 h-16 bg-gray-200 flex items-center justify-center rounded">
            LOGO
          </div>
        </div>

        <div className="text-right">
          <h1 className="text-2xl font-bold">
            ESMP APPROVAL RECEIPT
          </h1>
          <p className="text-gray-500">
            Environmental & Social Management Plan
          </p>
        </div>
      </div>

      {/* RECEIPT META */}
      <div className="relative z-10 grid grid-cols-2 gap-4 mb-6 border p-4 rounded-lg">
        <p>
          <strong>Receipt No:</strong> {receiptNumber}
        </p>
        <p className="text-right">
          <strong>Approval Date:</strong> {approvalDate}
        </p>
      </div>

      {/* DETAILS */}
      <div className="relative z-10 space-y-3">
        <p><strong>Project Name:</strong> {esmp.projectName}</p>
        <p><strong>District:</strong> {esmp.district}</p>
        <p><strong>Submitted By:</strong> {esmp.submittedBy}</p>
        <p>
          <strong>Status:</strong>{" "}
          <span className="text-green-700 font-semibold">
            {esmp.status}
          </span>
        </p>
      </div>

      {/* CONFIRMATION TEXT */}
      <div className="relative z-10 mt-8 border-t pt-6">
        <p>
          This document certifies that the Environmental and Social
          Management Plan (ESMP) for the above-mentioned project has
          been formally reviewed and approved in accordance with
          applicable environmental regulations and standards.
        </p>
      </div>

      {/* SIGNATURE */}
      <div className="relative z-10 mt-10 flex justify-between items-end">
        <div>
          <p className="font-semibold">Approved By:</p>
          <p>ESMP Administration Office</p>
          <p className="text-gray-500 text-xs mt-1">
            Authorized Authority
          </p>
        </div>

        <div className="text-center">
          <div className="w-40 h-10 border-b mb-1"></div>
          <p className="text-xs text-gray-500">Signature & Stamp</p>
        </div>
      </div>

      {/* FOOTER */}
      <div className="relative z-10 mt-10 text-xs text-gray-500 text-center border-t pt-4">
        This receipt is system-generated and valid without a physical
        signature. Any alteration renders this document invalid.
      </div>
    </div>
  )
})

export default ApprovalReceipt
